import React, { useReducer, useEffect } from "react";
import {
    MapContainer,
    GeoJSON,
    Polyline,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import { useCookies } from "react-cookie";
import { reducer, initialState, Context } from '../../store/reducer';
import NormalHeader from '../../components/Header/normal';
import MapController from '../../components/MapController';
import Spot from '../../components/Spot/register';
import Slider from '../../components/Slider';
import VectorGrid from "../../components/VectorGrid";
import VectorGrid63_1 from "../../components/VectorGrid63_1";
import VectorGrid77_3 from "../../components/VectorGrid77_3";
import VectorGrid99_3 from "../../components/VectorGrid99_3";
import Visualization32 from "../../components/Visualization32";
import Visualization34 from "../../components/Visualization34";
import Visualization36 from "../../components/Visualization36";
import Visualization38 from "../../components/Visualization38";
import Visualization39 from "../../components/Visualization39";
import { mapConfig } from '../../config/env';
import { spotList } from "../../components/Spot/register/config";
import { tmptestAPI } from "../../utils/api";
import { tmpAPI } from "../../utils/api";
import { kashika2Options } from "../../components/Header/normal/kashika2config";
import MenuSpot from "../../components/Spot/menu";
import Popup89 from "../../components/Spot/menu/popup89";
import Popup66 from "../../components/Spot/menu/popup66";
import PopupDefaultKeyLimited from "../../components/Spot/menu/popupDefaultKeyLimited";
import NoPopupMarker from "../../components/Spot/menu/noPopupMarker";

import MapUpdate from "../../components/MapUpdate";
import Geocoder from "../../components/Geocoder";
import MarkerClusterGroup from 'react-leaflet-markercluster';
import Popup92 from "../../components/Spot/menu/popup92";
import Vis99InformationModal from '../../components/Vis99InformationModal';

// 99_1 インフラ情報（流域下水道）ポンプ場
import Data_99_1 from '../../assets/data/99_1_data.json';

// 99_2 インフラ情報（流域下水道）マンホール
import Data_99_2 from '../../assets/data/99_2_data.json';

// 103 観測情報のため池
import Data_103 from '../../assets/data/103_data.json';

// 99_4 インフラ情報（流域下水道）浄化センター
import Data_99_4 from '../../assets/data/99_4_data.json';
import Vis90_16_5InformationModal from "../../components/Vis90_16_5InformationModal";
import Vis92TermInformationModal from "../../components/Vis92TermInformationModal";

const renderMarker = (option, d, index) => {

    if (option.id === "vis_66") {
        // 66: 連携データNo65-67：地域の砂防情報アーカイブ
        return <Popup66
          key={index.toString()}
          option={option}
          spot={d}
          latitude={d[option.column_lat]}
          longitude={d[option.column_lng]}
          menu={option.label}
          draggable={false}
        />
    } else if (option.id === "vis_89") {
        // 89: 瀬戸内海島しょ部	航路データ
        return <Popup89
          key={index.toString()}
          option={option}
          spot={d}
          latitude={d[option.column_lat]}
          longitude={d[option.column_lng]}
          menu={option.label}
          draggable={false}
        />
    } else {
        return <MenuSpot
          key={index.toString()}
          option={option}
          spot={d}
          latitude={d[option.column_lat]}
          longitude={d[option.column_lng]}
          menu={option.label}
          draggable={false}
        /> 
    }
}

/**
 * マーカーのクラスター表示
 * @param options
 * @param oneState
 * @returns {JSX.Element}
 */
const renderClusterMarker = (options, oneState) => {

    return (
      <MarkerClusterGroup chunkedLoading spiderfyOnMaxZoom={true}>
        { oneState.data.spots.map((d, index) =>
          <Popup92
            key={index.toString()}
            option={options}
            spot={d}
            latitude={d["緯度"]}
            longitude={d["経度"]}
            menu={options.label}
            draggable={false}
          />
        )}
    	</MarkerClusterGroup>
    )
}

const Layout = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    // eslint-disable-next-line
    const [cookies,setCookie,removeCookie] = useCookies(["spots"]);
    const spots = cookies.spots || [];
    useEffect(() => {
        kashika2Options.map(menu =>{
            menu.options.map(options => {

                if (options.type=='geojson') {
                    tmpAPI.get(options.url)
                        .then(res=>{
                            dispatch({
                                type: 'SET_DATA',
                                category: options.id,
                                payload: res.data
                            });
                        })
                } else if (options.severType == 'demo'){

                    // ファイルサーバーから取得する
                    tmpAPI.get(options.url)
                    .then(res=>{
                        dispatch({
                            type: 'SET_DATA',
                            category: options.id,
                            payload: res.data
                        });
                    })
                } else if (options.type == 'marker'){

                    if (options.id === "vis_99_1") {

                        // 99_1
                        dispatch({
                            type: 'SET_DATA',
                            category: "vis_99_1",
                            payload: Data_99_1
                        });

                    } else if (options.id === "vis_99_2") {

                        // 99_2
                        dispatch({
                            type: 'SET_DATA',
                            category: "vis_99_2",
                            payload: Data_99_2
                        });

                    } else if (options.id === "vis_99_4") {

                        // 99_4 浄化センター
                        dispatch({
                            type: 'SET_DATA',
                            category: "vis_99_4",
                            payload: Data_99_4
                        });

                    } else if (options.id === "vis_103") {

                        // 103 ため池(観測情報)
                        dispatch({
                            type: 'SET_DATA',
                            category: "vis_103",
                            payload: Data_103
                        });

                    } else {
                        
                        // データをマーカーの同様にAPIから取得する
                        tmptestAPI.get(options.url)
                        .then(res=>{
                            dispatch({
                                type: 'SET_DATA',
                                category: options.id,
                                payload: res.data
                            });
                        })
                    }
                
                } else if (options.id == 'vis_63_1'){

                    // 63_1: 河川管理情報システム (河川防災情報システム)	土砂災害危険度情報	土砂災害危険度テキストデータ　1kmメッシュ
                    // データをマーカーの同様にAPIから取得する
                    tmptestAPI.get(options.dataUrl)
                    .then(res=>{
                        dispatch({
                            type: 'SET_DATA',
                            category: options.id,
                            payload: res.data
                        });
                    })
                }
            })
        })

        tmptestAPI.get(process.env.REACT_APP_MENU)
        .then(res=>{
            // console.log(res)
            dispatch({
                type: 'SET_MENU',
                payload: res.data
          });
        })

    }, [])
    
    return (
        <Context.Provider value={{ state, dispatch }}>
            <NormalHeader />
            <main className="main">
                <div className="main-inner">

                    {
                        // インフラ情報（流域下水道）のモーダルはメニューチェック時にのみ表示される。
                        // 同意は3メニューとも同時に行なっているので、1つのメニューのisCheckedInModalを確認するだけで良い
                        ((state["vis_99_1"].checked
                                || state["vis_99_2"].checked
                                || state["vis_99_3"].checked
                                || state["vis_99_4"].checked)
                            && ! state["vis_99_1"].isCheckedInModal)
                        &&
                        <Vis99InformationModal></Vis99InformationModal>
                    }

                    {
                        // 道路台帳附図の利用規約ウインドウはメニューチェック時にのみ表示される。
                        // vis_92のisCheckedInModalを確認する
                        (state["vis_92"].checked
                            && ! state["vis_92"].isCheckedInModal)
                        &&
                        <Vis92TermInformationModal></Vis92TermInformationModal>
                    }

                    <MapContainer
                        tap={false}
                        id="map"
                        {...mapConfig}
                    >
                        <Geocoder/>
                        <MapUpdate />
                        <MapController />
                        {spots.map((spot, index) => (
                            state.registerMode ?  
                            <Spot
                                key={index.toString()}
                                index={index}
                                latitude={spot.latitude}
                                longitude={spot.longitude}
                                category={spot.category}
                                draggable={state.registerMode}
                            /> : state[spotList[spotList.findIndex(category => category.name == spot.category)].type] && 
                            <Spot
                                key={index.toString()}
                                index={index}
                                latitude={spot.latitude}
                                longitude={spot.longitude}
                                category={spot.category}
                                draggable={state.registerMode}
                            />
                        ))}
                        {kashika2Options.map(menu => {
                            return menu.options.map(options => {
                                if(options.type == "geojson" && state[options.id].checked) {

                                    let url, color, layerName
                                    switch (options.id) {
                                        case "shinsui":
                                            url       = process.env.REACT_APP_SHINSUI
                                            layerName = "70_takashio_max"
                                            color     = "#7C3AED"
                                            break;
                                        case "jisuberi":
                                            url       = process.env.REACT_APP_JISUBERI
                                            layerName = "78_3_jisuberi"
                                            color     = "#DB2777"
                                            break;
                                        case "toshi":
                                            url       = process.env.REACT_APP_LAYER_85_1_CITY
                                            layerName = "85_1_1_gyosei"
                                            color     = "#7C3AED"
                                            break;
                                        case "dosha-saigai":
                                            url       = process.env.REACT_APP_DOSHA_SAIGAI
                                            layerName = "76_dosekiryu"
                                            color     = "orange"
                                            break;
                                    }
                                    
                                    return <GeoJSON
                                      data={state[options.id].data}
                                      style={(feature) => {
                                          // ここで閾値によるスタイル設定
                                          //     if(feature["properties"]["ため池番号"] === "342121595"){
                                          //     return {
                                          //         color: "red"
                                          //     }
                                          // }
                                          return {
                                              color: options.color,
                                              opacity: options.opacity,
                                              fillOpacity: options.opacity
                                          }
                                      }}
                                    />

                                } else if(options.id == "vis_32" && state[options.id].checked) {
                                    // 32: 河川管理情報システム 雨量日集計
                                    return <Visualization32
                                      options={options}
                                    />
                                } else if(options.id == "vis_32" && state[options.id].checked) {
                                    // 32: 河川管理情報システム 雨量日集計
                                    return <Visualization32
                                      options={options}
                                    />
                                } else if(options.id == "vis_34" && state[options.id].checked) {
                                    // 32: 河川管理情報システム 水位日集計
                                    return <Visualization34
                                      options={options}
                                    />
                                } else if(options.id == "vis_36" && state[options.id].checked) {
                                    // 32: 河川管理情報システム ダム日集計
                                    return <Visualization36
                                      options={options}
                                    />
                                } else if(options.id == "vis_38" && state[options.id].checked) {
                                    // 32: 河川管理情報システム 潮位日集計
                                    return <Visualization38
                                      options={options}
                                    />
                                } else if(options.id == "vis_39" && state[options.id].checked) {
                                    // 32: 河川管理情報システム 風向風速日集計
                                    return <Visualization39
                                      options={options}
                                    />
                                } else if(options.id == "vis_63_1" && state[options.id].checked) {
                                    // 63_1: 河川管理情報システム (河川防災情報システム)	土砂災害危険度情報	土砂災害危険度テキストデータ　1kmメッシュ
                                    return <VectorGrid63_1
                                      id={options.id}
                                      url={options.url}
                                      layerName={options.layerName}
                                      color={options.color}
                                      opacity={options.opacity}
                                      borderColor={options.borderColor}
                                    />
                                } else if(options.id == "77_3_jisuberi" && state[options.id].checked) {
                                    // 地すべり危険箇所（77_3_jisuberi）

                                        return <VectorGrid77_3
                                            url={options.url}
                                            layerName={options.layerName}
                                            url2={options.url2}
                                            layerName2={options.layerName2}
                                            url3={options.url3}
                                            layerName3={options.layerName3}
                                            color={options.color}
                                            borderColor={options.borderColor}
                                        />

                                } else if(options.id == "vis_99_3" && state[options.id].checked) {
                                    // 99_3: インフラ情報（流域下水道） 管渠

                                    // モーダルでの同意がある場合のみ
                                    // vis99の3メニュー共通の同意のキーはメニューの1つである99_1
                                    if (state['vis_99_1'].isCheckedInModal) {
                                        return <VectorGrid99_3
                                            id={options.id}
                                            url={options.url}
                                            layerName={options.layerName}
                                            color={options.color}
                                            opacity={options.opacity}
                                            borderColor={options.borderColor}
                                        />
                                    }
                                } else if(options.type == "vector" && state[options.id].checked) {
                                    return <VectorGrid 
                                                id={options.id}
                                                url={options.url}
                                                layerName={options.layerName} 
                                                color={options.color}
                                                opacity={options.opacity}
                                                borderColor={options.borderColor}
                                            />
                                } else if(options.id=="tameike" && state.tameike.checked && state.tameike.data.spots){
                                    return state.tameike.data.spots.map(d => 
                                        <MenuSpot
                                            key={d["ため池番号"]}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="hinanjo" && state.hinanjo.checked && state.hinanjo.data.items){
                                    return state.hinanjo.data.items.map(d =>
                                        <MenuSpot
                                            key={d["facilityId"]}
                                            spot={d}
                                            latitude={d["latitude"]}
                                            longitude={d["longitude"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )   
                                } else if(options.id=="sabou" && state.sabou.checked && state.sabou.data.spots){
                                    return state.sabou.data.spots.map((d, index) => 
                                        <MenuSpot
                                            key={index.toString()}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )   
                                } else if(options.id=="sabousetsubi" && state.sabousetsubi.checked && state.sabousetsubi.data.spots){
                                    return state.sabousetsubi.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度"]}
                                        longitude={d["経度"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="kyoryo" && state.kyoryo.checked && state.kyoryo.data.spots){
                                   
                                    return state.kyoryo.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度（10進数）"]}
                                        longitude={d["経度（10進数）"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="hodokyo" && state.hodokyo.checked && state.hodokyo.data.spots){
                                   
                                    return state.hodokyo.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度（10進数）"]}
                                        longitude={d["経度（10進数）"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="tunnel" && state.tunnel.checked && state.tunnel.data.spots){

                                    return state.tunnel.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度（10進数）"]}
                                        longitude={d["経度（10進数）"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="doro-shed" && state["doro-shed"].checked && state["doro-shed"].data.spots){

                                    return state["doro-shed"].data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度（10進数）"]}
                                        longitude={d["経度（10進数）"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="doro-mongata" && state["doro-mongata"].checked && state["doro-mongata"].data.spots){

                                    return state["doro-mongata"].data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度（10進数）"]}
                                        longitude={d["経度（10進数）"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="damu" && state.damu.checked && state.damu.data.spots){

                                    return state.damu.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度"]}
                                        longitude={d["経度"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="77_2_kyukeisha" && state["77_2_kyukeisha"].checked && state["77_2_kyukeisha"].data.spots){
                                    
                                    return state["77_2_kyukeisha"].data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["緯度"]}
                                        longitude={d["経度"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="boring" && state["boring"].checked && state["boring"].data.spots){

                                    return state["boring"].data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["latitude"]}
                                        longitude={d["longitude"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="dorokisei_1" && state.dorokisei_1.checked && state.dorokisei_1.data.results){ //道路規制情報_本日の規制
                                    return state.dorokisei_1.data.results.map(d => {
                                        // iconというキーで要素を識別している点に注意
                                        return <MenuSpot
                                                    key={d["id"]}
                                                    spot={d}
                                                    latitude={d["lat"]}
                                                    longitude={d["lon"]}
                                                    menu={d["icon"]}
                                                    draggable={false}
                                                    option={options}
                                                />
                                    })
                                } else if(options.id=="dorokisei_2" && state.dorokisei_2.checked && state.dorokisei_2.data.results){ //道路規制情報_今後の規制
                                    return state.dorokisei_2.data.results.map(d => {
                                        // iconというキーで要素を識別している点に注意
                                        return <MenuSpot
                                                    key={d["id"]}
                                                    spot={d}
                                                    latitude={d["lat"]}
                                                    longitude={d["lon"]}
                                                    menu={d["icon"]}
                                                    draggable={false}
                                                    option={options}
                                                />
                                    })
                                } else if(options.id=="dorokisei_3" && state.dorokisei_3.checked && state.dorokisei_3.data.results){ //道路規制情報_事前通行規制区間情報
                                    return state.dorokisei_3.data.results.map((d, index) => {
                                        // iconというキーで要素を識別している点に注意
                                        return <MenuSpot
                                                    key={index.toString()}
                                                    option={options}
                                                    spot={d}
                                                    latitude={d["lat"]}
                                                    longitude={d["lon"]}   
                                                    menu={d["icon"]}
                                                    draggable={false}
                                                    option={options}
                                                />
                                    })
                                } else if(options.id=="dorokisei_4" && state.dorokisei_4.checked && state.dorokisei_4.data.spots){ //走行注意区間
                                    return state.dorokisei_4.data.spots.map(d => {
                                        const positions = d.gis.map(latlons => [latlons.map(latlon => [latlon.d, latlon.e])])
                                        return <Polyline positions={positions} pathOptions={{color:d.color}}/>
                                    })
                                } else if(options.id=="dorokisei_5" && state.dorokisei_5.checked && state.dorokisei_5.data.spots){ //緊急輸送道路
                                    return state.dorokisei_5.data.spots.map(d => {
                                        const positions = d.gis.map(gis => [gis.map(latlon => [latlon.d, latlon.e])])
                                        return <Polyline positions={positions} pathOptions={{color:d.color}}/>
                                    })
                                } else if(options.id=="sekisetusin_6_10" && state.sekisetusin_6_10.checked && state.sekisetusin_6_10.data.spots){ //気象情報_積雪データ
                                    return state.sekisetusin_6_10.data.spots.map((d, index) => 
                                        <MenuSpot
                                            key={index.toString()}
                                            option={options}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if([
                                      "vis_18",
                                      "vis_19",
                                      "vis_20",
                                      "vis_21", 
                                      "vis_22",
                                      "vis_66",
                                      "vis_78_3",
                                      "vis_89",
                                      "vis_95",
                                      "vis_103",
                                    ].includes(options.id)){
                                    
                                    /*
                                     * 汎用マーカー描画
                                     */

                                    if (state[options.id].checked && state[options.id].data.spots) {
                                        return state[options.id].data.spots.map((d, index) =>

                                          renderMarker(options, d, index)
                                          
                                        )
                                    }
                                    
                                } else if(options.id=="sabo_25" && state.sabo_25.checked && state.sabo_25.data.spots){ //堰堤工_詳細情報
                                    return state.sabo_25.data.spots.map(d => 
                                        <MenuSpot
                                            key={d["ため池番号"]}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="suimon_29" && state.suimon_29.checked && state.suimon_29.data.spots){ //水門・陸閘_詳細情報
                                    return state.suimon_29.data.spots.map((d, index) => 
                                        <MenuSpot
                                            key={index.toString()}
                                            spot={d}
                                            latitude={d["開始位置緯度"]}
                                            longitude={d["開始位置経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="kouwan_30_4" && state.kouwan_30_4.checked && state.kouwan_30_4.data.spots){ //海岸施設
                                    return state.kouwan_30_4.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["開始位置緯度"]}
                                        longitude={d["開始位置経度"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                } else if(options.id=="kouwan_30_1" && state.kouwan_30_1.checked && state.kouwan_30_1.data.spots){ //港湾設備_外郭施設
                                    return state.kouwan_30_1.data.spots.map((d, index)  => 
                                        <MenuSpot
                                            key={index.toString()}
                                            spot={d}
                                            latitude={d["開始位置緯度"]}
                                            longitude={d["開始位置経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="kouwan_30_2" && state.kouwan_30_2.checked && state.kouwan_30_2.data.spots){ //港湾設備_係留施設
                                    return state.kouwan_30_2.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                            spot={d}
                                            latitude={d["開始位置緯度"]}
                                            longitude={d["開始位置経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="kouwan_30_3" && state.kouwan_30_3.checked && state.kouwan_30_3.data.spots){ //港湾設備_臨港交通
                                    return state.kouwan_30_3.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                            spot={d}
                                            latitude={d["開始位置緯度"]}
                                            longitude={d["開始位置経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="kouwan_30_5" && state.kouwan_30_5.checked && state.kouwan_30_5.data.spots){ //漁港設備_外郭施設
                                    return state.kouwan_30_5.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                        spot={d}
                                        latitude={d["開始位置緯度"]}
                                        longitude={d["開始位置経度"]}
                                        menu={options.label}
                                        draggable={false}
                                      />
                                    )
                                    
                                } else if(options.id=="kouwan_30_6" && state.kouwan_30_6.checked && state.kouwan_30_6.data.spots){ //漁港設備_係留施設
                                    return state.kouwan_30_6.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                            spot={d}
                                        latitude={d["開始位置緯度"]}
                                        longitude={d["開始位置経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if(options.id=="kouwan_30_7" && state.kouwan_30_7.checked && state.kouwan_30_7.data.spots){ //漁港設備_臨港交通
                                    return state.kouwan_30_7.data.spots.map((d, index) =>
                                      <MenuSpot
                                        key={index.toString()}
                                            spot={d}
                                        latitude={d["開始位置緯度"]}
                                        longitude={d["開始位置経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                // } else if(options.id=="kasenkanri_31" && state.kasenkanri_31.checked && state.kasenkanri_31.data.spots){ //レイヤ名不明（河川管理情報システム（河川防災情報システム））
                                //     return state.kasenkanri_31.data.spots.map(d => 
                                //         <MenuSpot
                                //             key={d["ため池番号"]}
                                //             spot={d}
                                //             latitude={d["緯度"]}
                                //             longitude={d["経度"]}
                                //             menu={"ため池ポイント"}
                                //             draggable={false}
                                //         />
                                //     )
                                } else if(options.id=="chiiki_sabo_66" && state.chiiki_sabo_66.checked && state.chiiki_sabo_66.data.spots){ //伝承情報_災害情報
                                    return state.chiiki_sabo_66.data.spots.map((d, index) =>
                                        <MenuSpot
                                            key={index.toString()}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                        />
                                    )
                                } else if (options.id === 'vis_92' && state[options.id].checked && state[options.id].data.spots) {

                                    // 利用規約モーダルを確認した場合のみ表示する
                                    if (state["vis_92"].isCheckedInModal) {
                                        return renderClusterMarker(options, state[options.id])
                                    } else {
                                        return <></>
                                    }

                                } else if (['vis_99_1', 'vis_99_2', 'vis_99_4'].includes(options.id) && state[options.id].checked && state[options.id].data.spots) {

                                    // vis99の3メニュー共通の同意のキーはメニューの1つである99_1
                                    if (state['vis_99_1'].isCheckedInModal) {
                                        // ）
                                        if (options.id === 'vis_99_1') {
                                            return state[options.id].data.spots.map((d, index) =>
                                                <PopupDefaultKeyLimited
                                                    key={index.toString()}
                                                    option={options}
                                                    spot={d}
                                                    latitude={d[options.column_lat]}
                                                    longitude={d[options.column_lng]}
                                                    menu={options.label}
                                                    keyList={[
                                                        "GISデータの管理番号",
                                                        "施設名称",
                                                        "設置場所住所",
                                                        "圧送先名称"
                                                    ]}
                                                />
                                            )
                                        } else if (options.id === 'vis_99_2') {
                                            return state[options.id].data.spots.map((d, index) =>

                                                <PopupDefaultKeyLimited
                                                    key={index.toString()}
                                                    option={options}
                                                    spot={
                                                      { ...d,
                                                        ...{
                                                          "地盤高" : (d["地盤高"] && d["地盤高"] !== '') ? d["地盤高"]+"（TP.m）" : "",
                                                          "深さ" : (d["深さ"] && d["深さ"] !== '') ? d["深さ"]+"（m）" : ""
                                                        }
                                                      }
                                                    }
                                                    latitude={d[options.column_lat]}
                                                    longitude={d[options.column_lng]}
                                                    menu={options.label}
                                                    keyList={[
                                                        "GISデータの管理番号",
                                                        "人孔番号",
                                                        "地盤高",
                                                        "深さ",
                                                        "設置場所住所"
                                                    ]}
                                                />
                                            )
                                        } else if (options.id === 'vis_99_4') {

                                            // 浄化センターはポップアップ無し
                                            return state[options.id].data.spots.map((d, index) =>
                                                <NoPopupMarker
                                                    key={index.toString()}
                                                    option={options}
                                                    spot={d}
                                                    latitude={d[options.column_lat]}
                                                    longitude={d[options.column_lng]}
                                                    menu={options.label}
                                                />
                                            )
                                        }
                                    }


                                }
                            })
                        })}

                        {/* 可視化2の独自部分？ */}
                        {state.spots.map((spot, index) => (
                            <Spot
                                key={index.toString()}
                                index={index}
                                latitude={spot.latitude}
                                longitude={spot.longitude}
                                category={spot.category}
                                draggable={false}
                            />
                        ))}
                        
                    </MapContainer>
                    
                    {/* タイムスライダー */}
                    {((state["vis_32"] && state["vis_32"].checked)
                    || (state["vis_34"] && state["vis_34"].checked)
                      || (state["vis_36"] && state["vis_36"].checked)
                      || (state["vis_38"] && state["vis_38"].checked)
                      || (state["vis_39"] && state["vis_39"].checked)) && <Slider />}
                </div>
            </main>
        </Context.Provider>
    )
}

export default Layout;
